<template>
	<span class="content">
		<p>
			<Username :user="{nick: message.whois.nick}" />
			<span v-if="message.whois.whowas">
				est&aacute; desligado; &uacute;ltimas informa&ccedil;&otilde;es:</span
			>
		</p>

		<dl class="whois">
			<template v-if="message.whois.account">
				<dt>Ligado como:</dt>
				<dd>{{ message.whois.account }}</dd>
			</template>

			<dt>M&aacute;scara de rede:</dt>
			<dd class="hostmask">{{ message.whois.ident }}@{{ message.whois.hostname }}</dd>

			<template v-if="message.whois.actual_hostname">
				<dt>M&aacute;scara real:</dt>
				<dd class="hostmask">
					<a
						:href="'https://ipinfo.io/' + message.whois.actual_ip"
						target="_blank"
						rel="noopener"
						>{{ message.whois.actual_ip }}</a
					>
					<i v-if="message.whois.actual_hostname != message.whois.actual_ip">
						({{ message.whois.actual_hostname }})</i
					>
				</dd>
			</template>

			<template v-if="message.whois.real_name">
				<dt>Nome &quot;real&quot;:</dt>
				<dd><ParsedMessage :network="network" :text="message.whois.real_name" /></dd>
			</template>

			<template v-if="message.whois.registered_nick">
				<dt>Nick registado:</dt>
				<dd>{{ message.whois.registered_nick }}</dd>
			</template>

			<template v-if="message.whois.channels">
				<dt>Canais:</dt>
				<dd><ParsedMessage :network="network" :text="message.whois.channels" /></dd>
			</template>

			<template v-if="message.whois.modes">
				<dt>Modos:</dt>
				<dd>+{{ message.whois.modes.split("+")[1] }}</dd>
			</template>

			<template v-if="message.whois.special">
				<template v-for="special in message.whois.special">
					<dt :key="special">Special:</dt>
					<dd :key="special">{{ special }}</dd>
				</template>
			</template>

			<template v-if="message.whois.operator">
				<dt>Tipo de operador:</dt>
				<dd>{{ message.whois.operator }}</dd>
			</template>

			<template v-if="message.whois.helpop">
				<dt>Dispon&iacute;vel para ajudar:</dt>
				<dd>Sim</dd>
			</template>

			<template v-if="message.whois.away">
				<dt>Away:</dt>
				<dd><ParsedMessage :network="network" :text="message.whois.away" /></dd>
			</template>

			<template v-if="message.whois.secure">
				<dt>Liga&ccedil;&atilde;o segura:</dt>
				<dd>Sim</dd>
			</template>

			<template v-if="message.whois.server">
				<dt>Servidor:</dt>
				<dd>
					{{ message.whois.server }} <i>({{ message.whois.server_info }})</i>
				</dd>
			</template>

			<template v-if="message.whois.logonTime">
				<dt>Entrada:</dt>
				<dd>{{ localetime(message.whois.logonTime) }}</dd>
			</template>

			<template v-if="message.whois.idle">
				<dt>Idle:</dt>
				<dd>{{ localetime(message.whois.idleTime) }}</dd>
			</template>
		</dl>
	</span>
</template>

<script>
import localetime from "../../js/helpers/localetime";
import ParsedMessage from "../ParsedMessage.vue";
import Username from "../Username.vue";

export default {
	name: "MessageTypeWhois",
	components: {
		ParsedMessage,
		Username,
	},
	props: {
		network: Object,
		message: Object,
	},
	methods: {
		localetime(date) {
			return localetime(date);
		},
	},
};
</script>
